import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';
import Index from './index';
import { default as _Securities } from './pages/deals-pipeline/Securities';
import withQueryClientAndRouter from './components/withQueryClientAndRouter';

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: Index,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  errorBoundary(err, info, props) {
    return <div className="mt-16">Error</div>;
  },
  renderType: 'createRoot',
});

export const { bootstrap, mount, unmount } = lifecycles;

// used by @creditsights/creditsights-web MFE
export { getDealsTabs } from './pages/deals-pipeline/Securities.logic';
export { DealMarketStatus } from './models/CompanyDeal';
export { csSyncDataSubject$, SyncDataSubject } from './sharedSubjects';

// All components exported from this MFE should be listed below.
// Each and every component MUST be wrapped with `withQueryClientAndRouter` HOC to avoid runtime errors
const Securities = withQueryClientAndRouter(_Securities);
export { Securities };
